import { WarningCircle, X } from "@phosphor-icons/react";

const ContactInput = ({
    value,
    countryCode,
    onCountryCodeChange,
    onChange,
    onRemove,
    error,
    name,
    wrapperClassName = "input-group border-b-[1.5px] pt-3 pb-8 h-[146px]",
}) => {
    const handleContactChange = (e) => {
        const inputValue = e.target.value;
        // Allow only numeric input and limit to 10 digits
        if (/^\d*$/.test(inputValue) && inputValue.length <= 10) {
            onChange(inputValue);
        }
    };

    const handleCountryCodeChange = (e) => {
        onCountryCodeChange?.(e.target.value);
    };
    return (
        <div className={wrapperClassName}>
            {name && <label className="block text-sm">{name}</label>}
            <div className="border-[1.5px] flex mt-1 rounded-lg border-gray-300 h-[40px] items-center w-[95%] overflow-hidden">
                <select
                    value={countryCode}
                    onChange={handleCountryCodeChange}
                    className="p-1.5 outline-none"
                >
                    <option value="91">India (+91)</option>
                </select>
                <input
                    type="text"
                    value={value}
                    onChange={handleContactChange}
                    placeholder="Enter contact details"
                    className="block w-full rounded-md px-2 h-full outline-none"
                />
                {onRemove && (
                    <button
                        type="button"
                        onClick={onRemove}
                        aria-label={`Remove ${name || "contact"}`}
                        className="flex items-center justify-center h-full px-3 text-[#737880] border-l-[1.5px] border-gray-300"
                    >
                        <X size={14} weight="bold" />
                    </button>
                )}
            </div>
            {error && (
                <span className="text-[#E47186] text-xs flex items-center gap-1">
                    <WarningCircle className="text-sm" />
                    {error}
                </span>
            )}
        </div>
    );
};

export default ContactInput;
